import styled from 'styled-components'
import theme from 'theme_'

export const AddUserModalCloseBtn = styled.button`
  background-color: transparent;
  border: 0;
  outline: none;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: absolute;
  right: 29px;
  top: 21px;
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const AddUserModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`

export const AddUserModalHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.separatorColor};
  padding: 16px;
  margin-bottom: 32px;
  @media ${theme.devices.tablet} {
    border-bottom: none;
    padding: 24px;
    margin-bottom: 8px;
  }
`
